import Axios from "../config/Axios";


export const ApiCrearComidaPeriodo = async (data) => {
    try {
      const result = await Axios.post(`/POSTcreateComidaPeriodo`, data);
      return result.data;
    } catch (e) {
      return [
        {
          sms: "err",
          data: [],
          mensaje: e,
        },
      ];
    }
  };
  
export const ApiEditarComidaPeriodo= async (data) => {
    try {
        const result = await Axios.post(`/POSTeditComidaPeriodo`, data);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};

export const ApiActivarDesactivarComidaPeriodo = async (data) => {
    try {
        const result = await Axios.post(`/POSTtoggleEstadoComidaPeriodo`, data);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};

export const ApiDeleteComidaPeriodo = async (pre_comida_periodo_id) => {
    try {
        const result = await Axios.post(`/POSTdeleteComidaPeriodo`, pre_comida_periodo_id);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};


export const ApiGetAllComidasPeriodo = async (data) => {
    try {
        const result = await Axios.get(`/GETallComidasPeriodo`);
        return result.data;
    } catch (e) {
        return [
        {
            sms: "err",
            data: [],
            mensaje: e,
        },
        ];
    }
};


export const ApiGetDataComidaPeriodo = async (pre_comida_periodo_id) => {
try {
    const result = await Axios.get(`/GETdataComidaPeriodo/${pre_comida_periodo_id}`);
    return result.data;
} catch (e) {
    return [
    {
        sms: "err",
        data: [],
        mensaje: e,
    },
    ];
}
};